// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/site/img/no-photo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/site/img/heart_fav_outline.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/site/img/heart_fav_solid-active.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detail {
    margin-top: 56px;
}

@media screen and (max-width: 1024px) {
    .detail {
        margin-top: 0;
    }
}

.detail-wrap {
    display: flex;
    justify-content: center;
    /*max-width: 1044px;*/
    /*width: 100%;*/
    flex-direction: row;
    align-items: flex-start;
    margin: 0 auto;
}

@media screen and (max-width: 1024px) {
    .detail-wrap {
        flex-direction: column;
    }
}

.detail-left {
    flex: 1 1 auto;
    width: 66%;
    display: flex;
    flex-wrap: wrap;
}

.detail-left__no-photo {
    width: 100%;
    height: auto;
    aspect-ratio: 360 / 500;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
}

.detail-left__image {
    flex: 1 1 50%;
    max-width: 50%;
    display: flex;
    box-sizing: border-box;
    border: 1px solid #fff;
}

.detail-left__image > picture {
    display: flex;
}

@media screen and (max-width: 1024px) {
    .detail-left {
        display: block;
    }

    .detail-left .f-carousel__dots {
        display: none !important;
    }

    .detail-left__image {
        display: block;
        flex: 0 0 auto;
        /*width: 100%;*/
        max-width: none;
    }
}

@media screen and (max-width: 500px) {
    .detail-left {
        width: calc(100% + 40px);
        margin: 0 -20px 24px -20px;
    }
}

.detail-slider {
    display: none;
    max-width: 538px;
    width: 100%;
    height: 100%;
}

.detail-slider._active {
    display: flex;
    position: relative;
}

@media screen and (max-width: 1024px) {
    .detail-slider._active {
        display: block;
        position: relative;
    }
}

.detail-right {
    max-width: 400px;
    width: 100%;
    margin-left: 106px;
}

@media screen and (max-width: 1350px) {
    .detail-right {
        margin-left: 50px;
    }
}

@media screen and (max-width: 1200px) {
    .detail-right {
        margin-left: 37px;
    }
}

@media screen and (max-width: 1024px) {
    .detail-right {
        margin: 0 auto;
        max-width: 500px;
        width: 100%;
    }
}

.detail-title {
    font-size: 28px;
    line-height: 36px;
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
    text-transform: uppercase;
}

@media screen and (max-width: 1024px) {
    .detail-title {
        font-size: 24px;
        line-height: 32px;
    }
}

.detail-prices {
    margin-top: 20px;
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 30px;
}

@media screen and (max-width: 1024px) {
    .detail-prices {
        flex-wrap: wrap;
    }
}

.detail-prices__new {
    font-size: 20px;
    line-height: 26px;
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
    margin-right: 12px;
    position: relative;
}

.detail-prices__old {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-blackberry);
    text-decoration: line-through;
    margin-right: 16px;
}

.detail-prices__bonus {
    font-size: 12px;
    line-height: 20px;
    color: var(--color-blackberry);
    display: flex;
    align-items: center;
}

@media screen and (max-width: 1024px) {
    .detail-prices__bonus {
        width: 100%;
    }
}

.detail-prices__bonus-info {
    line-height: initial;
    margin-left: 4px;
}

.detail-prices__bonus-info svg {
    width: 18px;
    height: 18px;
}

.detail-prices__popup {
    display: none;
    position: absolute;
    top: 36px;
    left: 0;
    background: var(--color-white);
    box-shadow: 0px 2px 8px rgba(18, 38, 62, 0.15);
    border-radius: 4px;
    padding: 16px;
    width: 280px;
    z-index: 11;
}

.detail-prices__popup._active {
    display: block;
}

.detail-prices__popup:before {
    position: absolute;
    content: '';
    top: -12px;
    left: 24px;
    border-left: 10px solid transparent;
    border-bottom: 13px solid var(--color-white);
    border-right: 10px solid transparent;
    -webkit-filter: drop-shadow(0px 2px 8px rgba(18, 38, 62, 0.15));
    filter: drop-shadow(0px 2px 8px rgba(18, 38, 62, 0.15));
}

.detail-prices__popup-save {
    font-size: 18px;
    line-height: 24px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
    margin-bottom: 4px;
}

.detail-prices__popup-discount {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
    margin-bottom: 4px;
    font-family: "RalewayRegular";
}

.detail-prices__popup-stock {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
    font-family: "RalewayRegular";
}

.detail-color {
    margin-top: 30px;
    margin-bottom: 30px;
}

.detail-color__title {
    margin-bottom: 10px;
    text-transform: uppercase;
}

.detail-color__items {
    display: flex;
    flex-wrap: wrap;
    gap: 7px;
    flex-direction: row;
    /*align-items: flex-start;*/
    justify-content: flex-start;
}

.detail-color__item {
    flex: 0 0 auto;
    width: 60px;
    height: auto;
    aspect-ratio: 333 / 500;
    padding: 4px;
    border: 1px solid transparent;
    border-radius: 6px;
}

.detail-color__item.active {
    border: 1px solid var(--color-granite);
}

.detail-color__photo {
    object-fit: cover;
    width: 100%;
    height: 100%;
}

.detail-color__no-photo {
    width: 100%;
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
}

.detail-size {
    margin-top: 30px;
    margin-bottom: 30px;
}

.detail-size__title {
    margin-bottom: 10px;
    text-transform: uppercase;
}

.detail-size__items {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
}

.detail-size__item {
    cursor: pointer;
    position: relative;
}

.detail-size__value {
    background-color: #e5e5e5;
    color: var(--color-granite);
    padding: 5px 10px;
    border-radius: 6px;
    min-width: 45px;
    text-align: center;
    text-transform: uppercase;
}

@media screen and (max-width: 1024px) {
    .detail-size__value {
        min-width: auto;
    }
}

.detail-size__item > input {
    display: none !important;
}

.detail-size__item > input:checked + .detail-size__value {
    color: #e5e5e5;
    background-color: var(--color-granite);
}

.detail-size__item:not([data-basket-count='']):after {
    display: inline-block;
    position: absolute;
    height: 10px;
    width: 10px;
    background-color: #dd0000;
    border-radius: 5px;
    content: '';
    top: -5px;
    right: -5px;
}

.detail-size__item[data-basket-count='']:after,
.detail-size__item:not([data-basket-count]):after {
    display: none;
    content: none;
}

.detail-table {
    display: flex;
    align-items: center;
    margin-top: 12px;
}

.detail-table__size, .detail-table__pick {
    font-size: 14px;
    line-height: 20px;
    color: var(--color-blackberry);
}

.detail-table__size {
    margin-right: 16px;
}

.detail-error {
    color: var(--color-error);
    font-size: var(--font-s);
    text-align: left;
}

.detail-buy {
    margin-top: 26px;
    display: flex;
    align-items: center;
    gap: 15px;
    justify-content: stretch;
}

.detail-buy__btn {
    display: flex;
    flex: 1 1 auto;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    line-height: 28px;
    height: 56px;
    max-width: 336px;
    box-sizing: border-box;
    border: 1px solid var(--color-main);
}

.detail-buy__btn:last-child {
    flex: 1 0 auto
}

@media screen and (max-width: 1024px) {
    .detail-buy__btn {
        max-width: 100%;
    }
}

.detail-buy__btn._active {
    border: 1px solid var(--color-pale-blue);
    color: var(--color-main);
    background: var(--color-white);
}

.detail-buy__favorite {
    margin-left: 8px;
    width: 56px;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border: 1px solid var(--color-pale-blue);
    border-radius: 4px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
    background-size: 30px 30px;
}

.detail-buy__favorite._active {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center center;
    background-size: 30px 30px;
}

.detail-availability {
    font-size: 16px;
    line-height: 24px;
    font-family: "RalewaySemiBold";
    color: var(--color-main);
    margin-top: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    border: 1px solid var(--color-pale-blue);
    border-radius: 4px;
}

.detail-info {
    margin-top: 34px;
}

.detail-info__text {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    margin-bottom: 16px;
}

.detail-info__body {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 4px;
}

.detail-info__title {
    font-size: 16px;
    line-height: 24px;
}

.detail-info__value {
    padding-left: 8px;
}

.detail-accordion {
    margin-top: 32px;
}

.detail-accordion__item {
    border-bottom: 1px solid var(--color-light-periwinkle-crayola);
}

.detail-accordion__item._active .accordion-arrow {
    -webkit-transform: scaleY(-1);
    transform: scaleY(-1);
}

.detail-accordion__item._active .detail-accordion__body {
    display: block;
}

.detail-accordion__item._active .detail-size__top {
    background: transparent;
}

.detail-accordion__top {
    font-size: 16px;
    line-height: 24px;
    font-family: "RalewaySemiBold";
    color: var(--color-main);
    padding: 16px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}

.detail-accordion__top-title span {
    font-size: 16px;
    line-height: 24px;
    font-family: "RalewayRegular";
    color: var(--color-blackberry);
}

.detail-accordion__top-title svg {
    width: 12px;
    height: 12px;
}

.detail-accordion__body {
    display: none;
    margin-bottom: 16px;
}

.detail-accordion__body .availability-city {
    margin-bottom: 16px;
}

.detail-accordion__body .detail-size__top svg {
    margin-right: 8px;
}

.detail-accordion__body .detail-color__body {
    top: 40px;
}

.detail-accordion__body .reviews-top {
    margin-top: 6px;
    margin-bottom: 32px;
}

.detail-accordion__body .reviews-list {
    height: auto;
}

.detail-accordion__body-item {
    margin-bottom: 16px;
}

.detail-accordion__body-title {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
}

.detail-accordion__body-text {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
}

.detail-accordion__body-value {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
}

.detail-accordion__body-link {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-main);
    display: flex;
    align-items: center;
}

.detail-accordion__body-link svg {
    margin-left: 8px;
}

.detail-accordion__block {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
}

.detail-accordion__block svg {
    max-width: 32px;
    width: 100%;
    margin-right: 16px;
}

.detail-accordion__block-text {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
}

@media screen and (max-width: 1024px) {
    .detail + .info .info-wrap {
        width: 768px;
    }
}
`, "",{"version":3,"sources":["webpack://./resources/views/site/pages/detail/main.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,cAAc;IACd,UAAU;IACV,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;IAC5B,yDAA+D;IAC/D,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,cAAc;QACd,cAAc;QACd,eAAe;QACf,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,0BAA0B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,kBAAkB;IACtB;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,gBAAgB;QAChB,WAAW;IACf;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,8BAA8B;IAC9B,8CAA8C;IAC9C,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,UAAU;IACV,mCAAmC;IACnC,4CAA4C;IAC5C,oCAAoC;IACpC,+DAA+D;IAC/D,uDAAuD;AAC3D;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;IACnB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,4BAA4B;IAC5B,yDAA+D;IAC/D,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mCAAmC;AACvC;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,wCAAwC;IACxC,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,wCAAwC;IACxC,kBAAkB;IAClB,2EAA4F;IAC5F,0BAA0B;AAC9B;;AAEA;IACI,2EAAiG;IACjG,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,wBAAwB;IACxB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":[".detail {\n    margin-top: 56px;\n}\n\n@media screen and (max-width: 1024px) {\n    .detail {\n        margin-top: 0;\n    }\n}\n\n.detail-wrap {\n    display: flex;\n    justify-content: center;\n    /*max-width: 1044px;*/\n    /*width: 100%;*/\n    flex-direction: row;\n    align-items: flex-start;\n    margin: 0 auto;\n}\n\n@media screen and (max-width: 1024px) {\n    .detail-wrap {\n        flex-direction: column;\n    }\n}\n\n.detail-left {\n    flex: 1 1 auto;\n    width: 66%;\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.detail-left__no-photo {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 360 / 500;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-image: url(../../../../assets/site/img/no-photo.svg);\n    background-size: contain;\n}\n\n.detail-left__image {\n    flex: 1 1 50%;\n    max-width: 50%;\n    display: flex;\n    box-sizing: border-box;\n    border: 1px solid #fff;\n}\n\n.detail-left__image > picture {\n    display: flex;\n}\n\n@media screen and (max-width: 1024px) {\n    .detail-left {\n        display: block;\n    }\n\n    .detail-left .f-carousel__dots {\n        display: none !important;\n    }\n\n    .detail-left__image {\n        display: block;\n        flex: 0 0 auto;\n        /*width: 100%;*/\n        max-width: none;\n    }\n}\n\n@media screen and (max-width: 500px) {\n    .detail-left {\n        width: calc(100% + 40px);\n        margin: 0 -20px 24px -20px;\n    }\n}\n\n.detail-slider {\n    display: none;\n    max-width: 538px;\n    width: 100%;\n    height: 100%;\n}\n\n.detail-slider._active {\n    display: flex;\n    position: relative;\n}\n\n@media screen and (max-width: 1024px) {\n    .detail-slider._active {\n        display: block;\n        position: relative;\n    }\n}\n\n.detail-right {\n    max-width: 400px;\n    width: 100%;\n    margin-left: 106px;\n}\n\n@media screen and (max-width: 1350px) {\n    .detail-right {\n        margin-left: 50px;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    .detail-right {\n        margin-left: 37px;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .detail-right {\n        margin: 0 auto;\n        max-width: 500px;\n        width: 100%;\n    }\n}\n\n.detail-title {\n    font-size: 28px;\n    line-height: 36px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n    text-transform: uppercase;\n}\n\n@media screen and (max-width: 1024px) {\n    .detail-title {\n        font-size: 24px;\n        line-height: 32px;\n    }\n}\n\n.detail-prices {\n    margin-top: 20px;\n    display: flex;\n    align-items: center;\n    position: relative;\n    margin-bottom: 30px;\n}\n\n@media screen and (max-width: 1024px) {\n    .detail-prices {\n        flex-wrap: wrap;\n    }\n}\n\n.detail-prices__new {\n    font-size: 20px;\n    line-height: 26px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n    margin-right: 12px;\n    position: relative;\n}\n\n.detail-prices__old {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-blackberry);\n    text-decoration: line-through;\n    margin-right: 16px;\n}\n\n.detail-prices__bonus {\n    font-size: 12px;\n    line-height: 20px;\n    color: var(--color-blackberry);\n    display: flex;\n    align-items: center;\n}\n\n@media screen and (max-width: 1024px) {\n    .detail-prices__bonus {\n        width: 100%;\n    }\n}\n\n.detail-prices__bonus-info {\n    line-height: initial;\n    margin-left: 4px;\n}\n\n.detail-prices__bonus-info svg {\n    width: 18px;\n    height: 18px;\n}\n\n.detail-prices__popup {\n    display: none;\n    position: absolute;\n    top: 36px;\n    left: 0;\n    background: var(--color-white);\n    box-shadow: 0px 2px 8px rgba(18, 38, 62, 0.15);\n    border-radius: 4px;\n    padding: 16px;\n    width: 280px;\n    z-index: 11;\n}\n\n.detail-prices__popup._active {\n    display: block;\n}\n\n.detail-prices__popup:before {\n    position: absolute;\n    content: '';\n    top: -12px;\n    left: 24px;\n    border-left: 10px solid transparent;\n    border-bottom: 13px solid var(--color-white);\n    border-right: 10px solid transparent;\n    -webkit-filter: drop-shadow(0px 2px 8px rgba(18, 38, 62, 0.15));\n    filter: drop-shadow(0px 2px 8px rgba(18, 38, 62, 0.15));\n}\n\n.detail-prices__popup-save {\n    font-size: 18px;\n    line-height: 24px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n    margin-bottom: 4px;\n}\n\n.detail-prices__popup-discount {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n    margin-bottom: 4px;\n    font-family: \"RalewayRegular\";\n}\n\n.detail-prices__popup-stock {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n    font-family: \"RalewayRegular\";\n}\n\n.detail-color {\n    margin-top: 30px;\n    margin-bottom: 30px;\n}\n\n.detail-color__title {\n    margin-bottom: 10px;\n    text-transform: uppercase;\n}\n\n.detail-color__items {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 7px;\n    flex-direction: row;\n    /*align-items: flex-start;*/\n    justify-content: flex-start;\n}\n\n.detail-color__item {\n    flex: 0 0 auto;\n    width: 60px;\n    height: auto;\n    aspect-ratio: 333 / 500;\n    padding: 4px;\n    border: 1px solid transparent;\n    border-radius: 6px;\n}\n\n.detail-color__item.active {\n    border: 1px solid var(--color-granite);\n}\n\n.detail-color__photo {\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n}\n\n.detail-color__no-photo {\n    width: 100%;\n    height: 100%;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-image: url(../../../../assets/site/img/no-photo.svg);\n    background-size: contain;\n}\n\n.detail-size {\n    margin-top: 30px;\n    margin-bottom: 30px;\n}\n\n.detail-size__title {\n    margin-bottom: 10px;\n    text-transform: uppercase;\n}\n\n.detail-size__items {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 5px;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: flex-start;\n}\n\n.detail-size__item {\n    cursor: pointer;\n    position: relative;\n}\n\n.detail-size__value {\n    background-color: #e5e5e5;\n    color: var(--color-granite);\n    padding: 5px 10px;\n    border-radius: 6px;\n    min-width: 45px;\n    text-align: center;\n    text-transform: uppercase;\n}\n\n@media screen and (max-width: 1024px) {\n    .detail-size__value {\n        min-width: auto;\n    }\n}\n\n.detail-size__item > input {\n    display: none !important;\n}\n\n.detail-size__item > input:checked + .detail-size__value {\n    color: #e5e5e5;\n    background-color: var(--color-granite);\n}\n\n.detail-size__item:not([data-basket-count='']):after {\n    display: inline-block;\n    position: absolute;\n    height: 10px;\n    width: 10px;\n    background-color: #dd0000;\n    border-radius: 5px;\n    content: '';\n    top: -5px;\n    right: -5px;\n}\n\n.detail-size__item[data-basket-count='']:after,\n.detail-size__item:not([data-basket-count]):after {\n    display: none;\n    content: none;\n}\n\n.detail-table {\n    display: flex;\n    align-items: center;\n    margin-top: 12px;\n}\n\n.detail-table__size, .detail-table__pick {\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--color-blackberry);\n}\n\n.detail-table__size {\n    margin-right: 16px;\n}\n\n.detail-error {\n    color: var(--color-error);\n    font-size: var(--font-s);\n    text-align: left;\n}\n\n.detail-buy {\n    margin-top: 26px;\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    justify-content: stretch;\n}\n\n.detail-buy__btn {\n    display: flex;\n    flex: 1 1 auto;\n    justify-content: center;\n    align-items: center;\n    font-size: 18px;\n    line-height: 28px;\n    height: 56px;\n    max-width: 336px;\n    box-sizing: border-box;\n    border: 1px solid var(--color-main);\n}\n\n.detail-buy__btn:last-child {\n    flex: 1 0 auto\n}\n\n@media screen and (max-width: 1024px) {\n    .detail-buy__btn {\n        max-width: 100%;\n    }\n}\n\n.detail-buy__btn._active {\n    border: 1px solid var(--color-pale-blue);\n    color: var(--color-main);\n    background: var(--color-white);\n}\n\n.detail-buy__favorite {\n    margin-left: 8px;\n    width: 56px;\n    height: 56px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n    border: 1px solid var(--color-pale-blue);\n    border-radius: 4px;\n    background: url(\"../../../../assets/site/img/heart_fav_outline.svg\") no-repeat center center;\n    background-size: 30px 30px;\n}\n\n.detail-buy__favorite._active {\n    background: url(\"../../../../assets/site/img/heart_fav_solid-active.svg\") no-repeat center center;\n    background-size: 30px 30px;\n}\n\n.detail-availability {\n    font-size: 16px;\n    line-height: 24px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-main);\n    margin-top: 16px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 40px;\n    border: 1px solid var(--color-pale-blue);\n    border-radius: 4px;\n}\n\n.detail-info {\n    margin-top: 34px;\n}\n\n.detail-info__text {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    margin-bottom: 16px;\n}\n\n.detail-info__body {\n    display: grid;\n    grid-template-columns: 1fr 2fr;\n    gap: 4px;\n}\n\n.detail-info__title {\n    font-size: 16px;\n    line-height: 24px;\n}\n\n.detail-info__value {\n    padding-left: 8px;\n}\n\n.detail-accordion {\n    margin-top: 32px;\n}\n\n.detail-accordion__item {\n    border-bottom: 1px solid var(--color-light-periwinkle-crayola);\n}\n\n.detail-accordion__item._active .accordion-arrow {\n    -webkit-transform: scaleY(-1);\n    transform: scaleY(-1);\n}\n\n.detail-accordion__item._active .detail-accordion__body {\n    display: block;\n}\n\n.detail-accordion__item._active .detail-size__top {\n    background: transparent;\n}\n\n.detail-accordion__top {\n    font-size: 16px;\n    line-height: 24px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-main);\n    padding: 16px 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n}\n\n.detail-accordion__top-title span {\n    font-size: 16px;\n    line-height: 24px;\n    font-family: \"RalewayRegular\";\n    color: var(--color-blackberry);\n}\n\n.detail-accordion__top-title svg {\n    width: 12px;\n    height: 12px;\n}\n\n.detail-accordion__body {\n    display: none;\n    margin-bottom: 16px;\n}\n\n.detail-accordion__body .availability-city {\n    margin-bottom: 16px;\n}\n\n.detail-accordion__body .detail-size__top svg {\n    margin-right: 8px;\n}\n\n.detail-accordion__body .detail-color__body {\n    top: 40px;\n}\n\n.detail-accordion__body .reviews-top {\n    margin-top: 6px;\n    margin-bottom: 32px;\n}\n\n.detail-accordion__body .reviews-list {\n    height: auto;\n}\n\n.detail-accordion__body-item {\n    margin-bottom: 16px;\n}\n\n.detail-accordion__body-title {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n}\n\n.detail-accordion__body-text {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n}\n\n.detail-accordion__body-value {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n}\n\n.detail-accordion__body-link {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-main);\n    display: flex;\n    align-items: center;\n}\n\n.detail-accordion__body-link svg {\n    margin-left: 8px;\n}\n\n.detail-accordion__block {\n    display: flex;\n    align-items: center;\n    margin-bottom: 16px;\n}\n\n.detail-accordion__block svg {\n    max-width: 32px;\n    width: 100%;\n    margin-right: 16px;\n}\n\n.detail-accordion__block-text {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n}\n\n@media screen and (max-width: 1024px) {\n    .detail + .info .info-wrap {\n        width: 768px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
